import { Platform } from "react-native";
import styled, { css } from "styled-components/native";
import { radii, space, color } from "@sloth-system/styled-utils";
import {
  variant,
  backgroundColorProps,
  BackgroundColorProps,
  paddingProps,
  PaddingProps,
} from "@sloth-system/props";

export { Button };

type SlothProps = BackgroundColorProps & PaddingProps;
export interface ButtonStyleProps extends SlothProps {
  type?: "rounded" | "circle-like" | "full-circle";
  size?: "s" | "m" | "l";
  disabled?: boolean;
}

let disabledVariant = variant(
  "disabled",
  css`
    background-color: ${color("neutrals.300")};
  `
);

let typeVariant = variant("type", {
  rounded: css`
    border-radius: ${radii("s")};
  `,
  "circle-like": css`
    border-radius: ${radii("l")};
  `,
  "full-circle": css`
    border-radius: 200;
  `,
});

let sizeVariant = variant("size", {
  s: css`
    padding-top: ${space("s")};
    padding-bottom: ${space("s")};
    padding-left: ${space("m")};
    padding-right: ${space("m")};
  `,
  m: css`
    padding-top: ${space("m")};
    padding-bottom: ${space("m")};
    padding-left: ${space("l")};
    padding-right: ${space("l")};
  `,
  l: css`
    padding-top: ${space("l")};
    padding-bottom: ${space("l")};
    padding-left: ${space("xl")};
    padding-right: ${space("xl")};
  `,
});

let buttonWebStyles = "";
if (Platform.OS === "web") {
  buttonWebStyles = `display: block !important;`;
}

let Button = styled.TouchableOpacity<ButtonStyleProps>`
  ${buttonWebStyles}
  ${typeVariant}
  ${sizeVariant}
  ${backgroundColorProps}
  ${disabledVariant}
  ${paddingProps}
`;
